import React from "react";
import {toast} from "react-toastify";
import {FormattedMessage} from "react-intl";
import floatingIcon from "images/voiceChat/voice_chat_float_icon.svg";
import "react-toastify/dist/ReactToastify.css";
import styles from "./index.module.scss";
import {reject} from "lodash";

export const notify = (type, msg, name) => {
  return new Promise(resolve => {
    const defaultOptions = {
      position: "top-center",
      progress: undefined,
      hideProgressBar: true,
      closeButton: false,
      icon: () => <img src={floatingIcon} alt="" />,
    };

    const continueOptions = {
      pauseOnHover: false,
      closeOnClick: false,
      pauseOnFocusLoss: false,
      hideProgressBar: false,
      autoClose: 60000,
      className: "timer",
    };

    const message = (
      <FormattedMessage
        id={msg}
        values={{
          user: (
            <span className={type !== "textChat" ? styles.point_name : null}>
              {name}
            </span>
          ),
        }}
      />
    );

    let toastId;

    switch (type) {
      case "default":
        toastId = toast.dark(message, {
          ...defaultOptions,
          draggable: true,
          pauseOnHover: true,
          closeOnClick: true,
        });
        break;
      case "receive":
        toastId = toast.dark(
          <Receive
            message={message}
            actions={[
              () => {
                resolve("refuse");
              },
              () => {
                resolve("accept");
              },
            ]}
          />,
          {
            ...defaultOptions,
            ...continueOptions,
          },
        );
        break;
      case "send":
        toastId = toast.dark(
          <Send
            message={message}
            action={() => {
              resolve("button1");
            }}
          />,
          {
            ...defaultOptions,
            ...continueOptions,
          },
        );
        break;
      case "textChat":
        toastId = toast.info(message, {
          position: "top-center",
          progress: undefined,
          hideProgressBar: true,
          closeButton: false,
          icon: false,
          draggable: true,
          pauseOnHover: true,
          closeOnClick: true,
          autoClose: 2000,
        });
        break;
      default:
        resolve();
        break;
    }

    if (toastId) {
      toast.onChange(payload => {
        if (payload.status === "added") {
          if (toastId !== payload.id) {
            toast.dismiss(toastId);
          }
        } else if (payload.status === "removed") {
          if (payload.id === toastId) {
            reject();
          }
        }
      });
    }
  });
};

const Send = ({message, closeToast, action}) => {
  return (
    <div className={styles.send}>
      <div>{message}</div>
      <button
        className={styles.floating_btn}
        onClick={() => {
          action();
          closeToast();
        }}
      >
        <FormattedMessage id="ID_POPUP_BTN_CANCEL" />
      </button>
    </div>
  );
};

const Receive = ({message, closeToast, actions}) => {
  const [refuseCall, acceptCall] = actions;
  return (
    <div className={styles.receive}>
      <div>{message}</div>
      <div className={styles.btn_wrap}>
        <button
          className={styles.floating_btn}
          onClick={() => {
            refuseCall();
            closeToast();
          }}
        >
          <FormattedMessage id="ID_POPUP_BTN_REFUSAL" />
        </button>
        <button
          className={styles.floating_btn}
          onClick={() => {
            acceptCall();
            closeToast();
          }}
        >
          <FormattedMessage id="ID_POPUP_BTN_ACCEPT" />
        </button>
      </div>
    </div>
  );
};
